export function getBirthYearValidationMessage(value) {
    var currentYear = new Date().getFullYear();
    var birthYear = parseInt(value, 10);
    var oldestAllowedYear = currentYear - 120;
    if (birthYear < oldestAllowedYear)
        return 'You cannot be older than 120 years';
    if (birthYear > currentYear)
        return 'Birth year cannot be in the future';
}
export function isYoungerThenEighteen(birthYear) {
    var currentYear = new Date().getFullYear();
    var year = parseInt(birthYear, 10);
    var age = currentYear - year;
    return age < 18;
}
